import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems, intakeQuestions } from "../../data/landing";
export function BeforeAfter() {
  return <section className="px-4 py-16 sm:py-20" data-id="element-85" data-mp="26k03cji4wk0z">
      <div className="mx-auto max-w-5xl" data-id="element-86" data-mp="22lsmzprl1kqb">
        <SectionHeading title={<>
              From a technician who spends hours figuring out where to start…{" "}
              <em className="italic text-brand-600" data-id="element-88" data-mp="2ubp4mpcxoiu2">to one with a system for what to do next.</em>
            </>} lead="When an unfamiliar ECU arrives at your workshop, do you immediately know:" data-id="element-87" data-mp="22iofojitm8vf" />

        <ul className="mx-auto mt-6 grid max-w-3xl gap-2 sm:grid-cols-2" data-id="element-89" data-mp="2lah8actz9s2m">
          {intakeQuestions.map(q => <li key={q} className="rounded-xl border border-brand-100 bg-white px-4 py-3 text-base font-semibold text-ink" data-id="element-90" data-mp="1ewhwr27uz8qf">
              {q}
            </li>)}
        </ul>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg text-muted" data-id="element-91" data-mp="175vuwt4p1pkf">
          If the answer isn't always yes, that's exactly what I wanted to solve.{" "}
          <strong className="text-ink" data-id="element-92" data-mp="y57gvyfavp7j">I didn't create another giant library of random information. I created a decision system.</strong>
        </p>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-93" data-mp="131xxcmv0omth">
          <div className="rounded-3xl border-2 border-bad/20 bg-bad-light p-5 sm:p-7" data-id="element-94" data-mp="oemhi8rsygnk">
            <h3 className="flex items-center gap-2 text-xl font-extrabold uppercase text-bad" data-id="element-95" data-mp="t64nxcclh9fx">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-bad text-white" data-id="element-96" data-mp="feq1swne4s4n">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-97" data-mp="jf07073czeig" />
              </span>
              Before
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-98" data-mp="5hbmj0d7e9dx">
              {beforeItems.map(item => <li key={item.title} className="flex gap-3" data-id="element-99" data-mp="ae1zhetpoov4">
                  <XIcon className="mt-1 h-5 w-5 shrink-0 text-bad" aria-hidden="true" data-id="element-100" data-mp="2c498uiogathb" />
                  <div data-id="element-101" data-mp="2c63ww5v0r1pm">
                    <p className="font-bold leading-snug text-ink" data-id="element-102" data-mp="27d0z1lj7l63m">{item.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-103" data-mp="23byz12hgwq0l">{item.text}</p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-cta/30 bg-cta-light p-5 sm:p-7" data-id="element-104" data-mp="1yarrn4j8lsug">
            <h3 className="flex items-center gap-2 text-xl font-extrabold uppercase text-cta-dark" data-id="element-105" data-mp="2v2c1d7g7j8jv">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cta text-white" data-id="element-106" data-mp="2r2bgb3ylrz3u">
                <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-107" data-mp="2m4jm23ahk0wh" />
              </span>
              After — with ECU Decision System™
            </h3>
            <ul className="mt-5 space-y-4" data-id="element-108" data-mp="1anjtd6k87k1x">
              {afterItems.map(item => <li key={item.title} className="flex gap-3" data-id="element-109" data-mp="15nnol53pfolb">
                  <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-cta-dark" aria-hidden="true" data-id="element-110" data-mp="15qjqf4ioaxf1" />
                  <div data-id="element-111" data-mp="viffh7k3olue">
                    <p className="font-bold leading-snug text-ink" data-id="element-112" data-mp="10j3fgiqb4d0r">{item.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-113" data-mp="15ig3h6swzq4x">{item.text}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>

        <CTAButton className="mt-10" label="I want a system for ECU diagnosis" data-id="element-114" data-mp="1aazim8792tbu" />
      </div>
    </section>;
}